import { stringToNumber } from './stringToNumber';

/**
 * Angular-фильтр для шаблона.
 * Форматирует цены с точностью до второго знака.
 *
 * @param {string} Цена
 *
 * @returns number
 */
export const priceFilter = () => {
  return (input) => {
    const number = stringToNumber(input);

    return number.toLocaleString('ru-RU', {
      // Избавляемся от дробной части у целых
      minimumFractionDigits: (number % 1 === 0) ? 0 : 2
    });
  };
};
